var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center login-page"},[_c('app-login-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }